import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const MethodologyPage = () => (
  <>
    <Header />
    <main className="main page-content">
      <h1 className="page-title">Our Methodology</h1>
      
      <section className="methodology-section">
        <h2>How It Works</h2>
        <div className="methodology-steps">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Ingest</h3>
            <p>We poll RSS feeds from 20+ major news outlets across 5 global regions every 15 minutes.</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Cluster</h3>
            <p>Articles about the same event are grouped together using semantic similarity analysis.</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Analyze</h3>
            <p>We detect 10 mechanical framing signals in each article - no subjective judgments.</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Display</h3>
            <p>Stories are presented side-by-side so you can see how different regions frame the same event.</p>
          </div>
        </div>
      </section>
      
      <section className="methodology-section">
        <h2>What We Don't Do</h2>
        <ul className="anti-list">
          <li><strong>No bias scores</strong> - We don't rate outlets as left/right or trustworthy</li>
          <li><strong>No editorial opinions</strong> - We don't summarize or interpret the news</li>
          <li><strong>No personalization</strong> - Everyone sees the same stories, no filter bubbles</li>
          <li><strong>No black boxes</strong> - Every signal we detect is inspectable</li>
        </ul>
      </section>
      
      <section className="methodology-section">
        <h2>Framing Signals</h2>
        <p>We detect these 10 mechanical signals in each article:</p>
        <div className="framing-tags-grid">
          {[
            'Quotes Government Official',
            'Quotes Opposition/Critics',
            'Mentions Casualties',
            'Cites Data/Statistics',
            'Includes Historical Context',
            'Quotes Expert/Analyst',
            'Includes Future Speculation',
            'Covers International Reaction',
            'Discusses Economic Impact'
          ].map(tag => (
            <div key={tag} className="framing-tag-item">{tag}</div>
          ))}
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default MethodologyPage;
